export enum MyScorecardCard {
    RELOAD = 'myScorecard.reload',
    PERIOD_TYPE_CHANGE = 'myScorecard.periodTypeChange',
    TREND_ACTION = 'myScorecard.trendAction',
    SELECT_ACTION = 'myScorecard.selectAction',
    EXPAND_CLICK = 'myScorecard.expandClick',
    PREV_SCORECARD_CLICK = 'myScorecard.prevScClick',
    NEXT_SCORECARD_CLICK = 'myScorecard.nextScClick',
    NAVIGATE = 'myScorecard.navigate',
}
